import React from "react";
import ProviderOverviewSection from "./ProviderOverviewSection";
import {
  providerLanguages,
  speciality,
} from "../../../constants/providerInfoData";
import ProviderLanguagesSection from "./ProviderLanguagesSection";
import "./providerInfo.scss";
import ProviderSpeciality from "./ProviderSpeciality";

const ProviderInfo = () => {
  
  return (
    <div className="container-right">
      <div>
        <ProviderOverviewSection />
      </div>
      <ProviderSpeciality data={speciality} />
      <ProviderLanguagesSection data={providerLanguages} />
    </div>
  );
};

export default ProviderInfo;
